import React, { useEffect, useState } from "react";
import { Card, Col, Collapse, Row, Statistic, Tag } from "antd";
import ProgressGraph from "./ProgressGraph";
import {
  ArrowDownOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import GetPositionPerformanceApi from "../../api/individuals/GetPositionPerformanceApi";

function PositionPerformanceOverview() {
  const [data, setData] = useState();
  const perfCycleState = useSelector((state) => state.perfCycleState.value);

  let curLocation = useLocation();

  useEffect(() => {
    getUserPerformance();
  }, [curLocation]);

  async function getUserPerformance() {
    let path = curLocation.pathname;
    let id = path.split("/positions-performance/");
    const apiResponse = await GetPositionPerformanceApi(
      id[1],
      perfCycleState.id
    );
    if (apiResponse.message === "success") {
      setData(apiResponse.data);
    }
  }

  return (
    <div className="pb-8">
      <div className="mb-6">
        <Statistic
          title="CURRENT PROGRESS"
          value={data?.currentProgress}
          prefix={<ArrowDownOutlined style={{ color: "red" }} />}
          suffix="% completed"
        />
      </div>
      <Card
        style={{
          borderColor: "#e5e7eb",
          marginBottom: "24px",
        }}
      >
        <div className="text-base pri-font mb-4">Progress predictions</div>
        <ProgressGraph currentProgress={data?.currentProgress} />
      </Card>
      <Card
        style={{
          borderColor: "#e5e7eb",
          marginBottom: "24px",
          cursor: "pointer",
        }}
      >
        <div className="text-base pri-font mb-3">Objectives</div>
        <Row gutter={12}>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "blue" }}
              prefix={<QuestionCircleOutlined />}
              title="Total"
              value={data?.objectives?.Total}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "green" }}
              prefix={<CheckCircleOutlined />}
              title="OnTrack"
              value={data?.objectives?.OnTrack}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "orange" }}
              prefix={<ClockCircleOutlined />}
              title="OffTrack"
              value={data?.objectives?.OffTrack}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "red" }}
              prefix={<ExclamationCircleOutlined />}
              title="AtRisk"
              value={data?.objectives?.AtRisk}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default PositionPerformanceOverview;
